import { getMethods as getObjectsMethods } from './Objects';
import { getMethods as getExplorerMethods } from './Explorer';
import { getMethods as getStartupMethods } from './Startup';
import { getMethods as getRecycleBinMethods } from './RecycleBin';
import { getMethods as getEnrichmentMethods } from './Enrichment';
import { getMethods as getAIMethods } from './AI';

const getController = (service: 'dm') => ({
	Objects: getObjectsMethods(service, 'DocumentManagement/Objects'),
	Explorer: getExplorerMethods(service, 'DocumentManagement/Explorer'),
	Startup: getStartupMethods(service, 'DocumentManagement/Startup'),
	RecycleBin: getRecycleBinMethods(service, 'DocumentManagement/RecycleBin'),
	Enrichment: getEnrichmentMethods(service, 'DocumentManagement/Enrichment'),
	AI: getAIMethods(service, 'DocumentManagement/AI')
});

export { getController };
